import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFinancials extends Layout {
    checkboxCreditApplication: Checkbox;
    headingAvailableCredit: Label;
    headingCashReceiptsTotal: Label;
    headingMiscBillTotal: Label;
    headingOrdersNotRated: Label;
    headingPastDueTotal: Label;
    headingUnbilledTotal: Label;
    labelAvailableCredit: Label;
    labelCashReceiptsTotal: Label;
    labelMiscBillTotal: Label;
    labelOrdersNotRated: Label;
    labelPastDueTotal: Label;
    labelUnbilledTotal: Label;
    panelFinancials1: Panel;
    panelFinancials2: Panel;
    panelFinancials3: Panel;
    panelTotals1: Panel;
    panelTotals2: Panel;
    panelTotals3: Panel;
    panelTotals4: Panel;
    panelTotals5: Panel;
    panelTotals6: Panel;
    panelTotals: Panel;
    sourceCustAging: DataSource;
    sourceCustomer: DataSource;
    textboxAverageBill: Textbox;
    textboxAveragePayDays: Textbox;
    textboxBalance: Textbox;
    textboxBilledLoads: Textbox;
    textboxCreditCheckDate: Textbox;
    textboxCreditLimit: Textbox;
    textboxCreditStatus: Textbox;
    textboxCreditWarningPct: Textbox;
    textboxCurrencyType: Textbox;
    textboxHighBalance: Textbox;
    textboxInvoiceProcessingUser: Textbox;
    textboxLastBillDate: Textbox;
    textboxLastPayDate: Textbox;
    textboxLastShipDate: Textbox;
    textboxPaidLoads: Textbox;
    textboxPayDaysDate: Textbox;
}
